/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reason: NonNullable<unknown> }} Backend_Session_Error_FailedInputs */

const en_backend_session_error_failed = /** @type {(inputs: Backend_Session_Error_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The session failed on the backend side: ${i?.reason}. Please retry.`)
};

const fr_backend_session_error_failed = /** @type {(inputs: Backend_Session_Error_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La session a échoué côté backend : ${i?.reason}. Réessayez.`)
};

const ms_sg2_backend_session_error_failed = /** @type {(inputs: Backend_Session_Error_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sesi gagal di pihak backend: ${i?.reason}. Sila cuba semula.`)
};

/**
* | output |
* | --- |
* | "The session failed on the backend side: {reason}. Please retry." |
*
* @param {Backend_Session_Error_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const backend_session_error_failed = /** @type {((inputs: Backend_Session_Error_FailedInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backend_Session_Error_FailedInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backend_session_error_failed(inputs)
	if (locale === "fr") return fr_backend_session_error_failed(inputs)
	return ms_sg2_backend_session_error_failed(inputs)
});